module.exports = __webpack_public_path__ + "static/media/Paratiisi-BG-Image-300x140.d8561a10.png";